import { getArticlesAuthoeBtArticleAndProfessorId, getArticlesByWWorkflowUserId } from "@/api/article";
import { useQuery } from "@tanstack/react-query";

export const useArticle = (id: string) => {
  return useQuery({
    queryFn: () => getArticlesByWWorkflowUserId(id),
    queryKey: ["profile", id],
    refetchOnMount: true
  });
};

export const useAuthorArticle = (professorId: number, articleId: number) => {
  return useQuery({
    queryFn: () => getArticlesAuthoeBtArticleAndProfessorId(professorId, articleId),
    queryKey: ["profile", professorId, articleId], 
    enabled: !!articleId, 
    refetchOnMount: true
  });
};
